export default __webpack_public_path__ + "static/media/campaigns.a8ed482c.jpg";